import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8572a466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container" }
const _hoisted_2 = { class: "text-container" }
const _hoisted_3 = { class: "text-primary-language" }
const _hoisted_4 = {
  key: 0,
  class: "text-secondary-language"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.text_label_lang1), 1),
      (_ctx.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.text_label_lang2), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}